import { Conseiller, Dossier, Personne } from '@axa-fr-axion/user-journey-services';
import { Draft, produce } from 'immer';
import mergeWith from 'lodash.mergewith';
import { JourneyAction, JourneyData, JourneyReducer } from './App.interface';
import { isIdentityValid, selectDefaultAdvisor, toHomeAdress, toIdentity } from './App.utils';

export function handleInitialize(
    state: JourneyData,
    action: Extract<JourneyAction, { type: 'INITIALIZE' }>,
): JourneyData {
    return produce(state, (draft) => {
        draft.folder = action.folder as Draft<Dossier>;
        draft.identity = action.folder.personne ? toIdentity(action.folder.personne) : draft.identity ;

        draft.isIdentityValid = isIdentityValid(draft.identity);

        const homeAddress = action.folder.personne?.adresse ?
            toHomeAdress(action.folder.personne?.adresse) : draft.homeAddress;
        draft.homeAddress = homeAddress;
        if (homeAddress.address && homeAddress.city && homeAddress.postalCode) {
            draft.isHomeAddressValid = true;
        }
    });
}

export function handleSelectAdvisor(
    state: JourneyData,
    action: Extract<JourneyAction, { type: 'SELECT_ADVISOR' }>,
): JourneyData {
    return produce(state, (draft) => {
        draft.selectedAdvisor = action.advisor as Draft<Conseiller>;
    });
}

export function handleSetConfirmation(
    state: JourneyData,
    action: Extract<JourneyAction, { type: 'SET_CONFIRMATION' }>,
): JourneyData {
    return produce(state, (draft) => {
        draft.folder = action.folder as Draft<Dossier>;
    });
}

export function handleSetDefaultAdvisor(
    state: JourneyData,
    action: Extract<JourneyAction, { type: 'SET_DEFAULT_ADVISOR' }>,
): JourneyData {
    return produce(state, (draft) => {
        draft.folder = action.folder as Draft<Dossier>;

        const advisor: Conseiller | undefined = selectDefaultAdvisor(action.folder);
        if (advisor) {
            draft.selectedAdvisor = advisor as Draft<Conseiller>;
        }
    });
}

export function handleSetPersonne(
    state: JourneyData,
    action: Extract<JourneyAction, { type: 'SET_PERSONNE' }>,
): JourneyData {
    return produce(state, (draft) => {
        draft.folder = action.folder as Draft<Dossier>;
        if (action.folder.personne) {
            draft.folder.personne = action.folder.personne as Draft<Personne>;
        }
    });
}

export const journeyReducer: JourneyReducer =
    (state: JourneyData, action: JourneyAction): JourneyData => {
        switch (action.type) {
            case 'INITIALIZE':
                return handleInitialize(state, action);
            case 'SELECT_ADVISOR':
                return handleSelectAdvisor(state, action);
            case 'SET_CONFIRMATION':
                return handleSetConfirmation(state, action);
            case 'SET_DEFAULT_ADVISOR':
                return handleSetDefaultAdvisor(state, action);
            case 'SET_PERSONNE':
                return handleSetPersonne(state, action);
            default:
                return mergeWith({}, state, action.payload, (_, srcValue) => {
                    if (Array.isArray(srcValue) || (typeof srcValue === 'object' && !Array.isArray(srcValue) && srcValue !== null)) {
                        // Replaces array properties
                        return srcValue;
                    }
                    return undefined;
                });
        }
    };
